module.exports = __webpack_public_path__ + "img/1.41a9c6e4.png";